<template>
  <div class="inner">

    <div class="content_title">
      <div class="nav">
        <h1>{{$LangMessage(LangKey.MyInvoice)}}</h1>
      </div>
    </div>

    <div id="UCP_invoice">
      <div class="tabs">
        <div class="tab" :class="{on:tabShow}" @click="showData(true)"><span>{{$LangMessage(LangKey.Generate)}}</span></div>
        <div class="tab" :class="{on:!tabShow}" @click="showData(false)"><span>{{$LangMessage(LangKey.Download)}}</span></div>
      </div>

      <div class="wrapper" :class="{show:tabShow}" id="generate_invoice">
        <h2>{{$LangMessage(LangKey.GenerateInvoice)}}</h2>
        <div class="tips">{{$LangMessage(LangKey.GenerateInvoiceTips)}}</div>

        <no-invoice v-if="!this.hasReceipt" :message="$LangMessage(LangKey.NoGenerateInvoice)"/>


        <template v-if="this.hasReceipt">

          <step-section data-step>
            <h3>{{$LangMessage(LangKey.GenerateInvoice)}}</h3>
            <div id="invoice_trade_list" ref="invoiceTradeList">
              <label v-for="item in dataList">
                <input type="checkbox" v-model="selectReceipts" :value="item.receipt_id">
                <div class="trade">
                  <div class="pid">P{{item.trade_id}}</div>
                  <div class="time">{{$parseTime(item.created * 1000)}}</div>
                  <div class="price">{{ item.receipt_amount_format }}</div>
                  <div class="details">
                    <div class="item">{{ item.category_name }}</div>
                    <div class="sku">{{ item.title }}</div>
                    <div class="qtt">× {{ item.quantity }}</div>
                  </div>
                </div>
              </label>
            </div>
          </step-section>

          <step-section data-step id="step2">
            <h3>{{$LangMessage(LangKey.FillInYourInformation)}}</h3>
            <div id="invoice_information">
              <div class="recent">
                <div class="title">{{$LangMessage(LangKey.RecentlyUsed)}}</div>
                <div class="info">
                  <div class="recent_submit" icon="contact_page" v-for="item in invoiceInfoList"><span  @click="invoiceInfoToNew(item)">{{item.invoice_info_string}}</span></div>
                </div>
              </div>
              <div class="form">
                <div class="T required">{{$LangMessage(LangKey.Country)}}</div>
                <div class="C">
                  <label class="cpt-select">
                    <select name="country_name" v-model="invoiceInfo.buyer_country_code" @change="changeBuyerRegion">
                      <option :value="item.Code" v-for= "item in CountryCodes">{{item.Country}}</option>
                    </select>
                  </label>
                </div>

                <div class="T required" v-if="invoiceInfo.buyer_country_code === 'MYS'">{{$LangMessage(LangKey.State)}}</div>
                <div class="C" v-if="invoiceInfo.buyer_country_code == 'MYS'">
                  <label class="cpt-select">
                    <select name="city_code" v-model="invoiceInfo.buyer_state_code">
                      <option :value="item.Code" v-for= "item in StateCodes">{{item.State}}</option>
                    </select>
                  </label>
                </div>

                <div class="T required">{{$LangMessage(LangKey.City)}}</div>
                <div class="C">
                  <label class="cpt-text"><input ref="buyerCityName" type="text" v-model="invoiceInfo.buyer_city_name" :placeholder="$LangMessage(LangKey.City)"></label>
                </div>

                <div class="T required">{{$LangMessage(LangKey.Address)}}</div>
                <div class="C">
                  <label class="cpt-text"><input type="text" ref="address" v-model="invoiceInfo.buyer_address" :placeholder="$LangMessage(LangKey.YourAddress)"></label>
                </div>


                <!--非马来西亚 brn 可不填-->
                <div class="T" v-if="invoiceInfo.buyer_country_code !== 'MYS' && invoiceInfo.invoice_type === 'BRN'">{{$LangMessage(LangKey.Identification)}}</div>
                <div class="T required" v-else >{{$LangMessage(LangKey.Identification)}}</div>
                <div class="C">
                  <label class="cpt-select">
                    <select name="type_of_invoice" v-model="invoiceInfo.invoice_type" @change="changeInvoiceType">
                      <option value="NRIC">NRIC</option>
                      <option value="PASSPORT">Passport</option>
                      <option value="BRN">BRN</option>
                      <option value="ARMY">Army</option>
                    </select>
                  </label>


                  <!--NRIC-->
                  <template v-if="invoiceInfo.invoice_type === 'NRIC'">
                  <label class="cpt-text">
                    <input type="text" inputmode="numeric" ref="buyerIdentity" v-model="invoiceInfo.buyer_identity"  :placeholder="$LangMessage(LangKey.IdentificationNumber)" @keyup="inputDigt"/>
                  </label>
                  <div class="tips_wrp">
                    <div class="tips">{{$LangMessage(LangKey.RequiredArmy)}}</div>
                  </div>
                  </template>

                  <!--Passport 去掉-->

                  <!--BRN-->
                  <template v-if="invoiceInfo.invoice_type === 'BRN'">
                    <label class="cpt-text">
                      <input type="text" ref="buyerIdentity" v-model="invoiceInfo.buyer_identity"  placeholder="BRN" />
                    </label>
                    <div class="tips_wrp">
                      <div class="tips">{{$LangMessage(LangKey.RequiredBRN)}}</div>
                    </div>
                  </template>

                  <!--ARMY-->
                  <template v-if="invoiceInfo.invoice_type === 'ARMY'">
                    <label class="cpt-text">
                      <input type="text" inputmode="numeric" ref="buyerIdentity" v-model="invoiceInfo.buyer_identity"  placeholder="ARMY" @keyup="inputDigt"/>
                    </label>
                    <div class="tips_wrp">
                      <div class="tips">{{$LangMessage(LangKey.RequiredArmy)}}</div>
                    </div>
                  </template>
                </div>

                <!--NRIC ARMY-->
                <template v-if="invoiceInfo.invoice_type === 'NRIC'|| invoiceInfo.invoice_type === 'ARMY'">
                <div class="T required" >{{$LangMessage(LangKey.YourName)}}</div>
                <div class="C">
                  <label class="cpt-text"><input type="text" ref="buyerName" v-model="invoiceInfo.buyer_name" :placeholder="$LangMessage(LangKey.YourName)"></label>
                </div>
                </template>

                <!--Passport-->
                <template v-if="invoiceInfo.invoice_type === 'PASSPORT'">
                  <div class="T required" >{{$LangMessage(LangKey.PassportName)}}</div>
                  <div class="C">
                    <label class="cpt-text"><input type="text" ref="buyerName" v-model="invoiceInfo.buyer_name" :placeholder="$LangMessage(LangKey.PassportName)"></label>
                  </div>
                </template>

                <!--BRN-->
                <template v-if="invoiceInfo.invoice_type === 'BRN'">
                  <div class="T required" >{{$LangMessage(LangKey.CompanyName)}}</div>
                  <div class="C">
                    <label class="cpt-text"><input type="text" ref="buyerName" v-model="invoiceInfo.buyer_name" :placeholder="$LangMessage(LangKey.CompanyName)"></label>
                  </div>
                </template>

                <div class="T" v-if="invoiceInfo.buyer_country_code === 'MYS' && invoiceInfo.invoice_type === 'BRN'">SST</div>
                <div class="C" v-if="invoiceInfo.buyer_country_code === 'MYS'&& invoiceInfo.invoice_type === 'BRN' ">
                  <label class="cpt-text"><input type="text" v-model="invoiceInfo.buyer_sst" placeholder="SST"></label>
                  <div class="tips_wrp">
                    <div class="tips">{{$LangMessage(LangKey.RequiredSST)}}</div>
                  </div>
                </div>

                <div class="T">{{$LangMessage(LangKey.Email)}}</div>
                <div class="C">
                  <label class="cpt-text"><input type="text" ref="email" v-model="invoiceInfo.buyer_email" :placeholder="$LangMessage(LangKey.YourEmail)"></label>
                  <div class="tips_wrp">
                    <div class="tips">{{$LangMessage(LangKey.IFNotApplicable)}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div id="invoice_btc">
              <a @click="createInvoice" class="btw" color="theme"><span>{{$LangMessage(LangKey.SubmitInvoiceInformation)}}</span></a>
            </div>
          </step-section>

        </template>


      </div>

      <div class="wrapper" :class="{show:!tabShow}" id="download_invoice">
        <h2>{{$LangMessage(LangKey.DownloadInvoice)}}</h2>
        <div class="tips">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Saepe natus non reprehenderit assumenda qui odio a. Aperiam a, ab iure magni suscipit recusandae non perferendis, fugiat vel voluptas? Atque quam perferendis nam amet aliquid sed facilis nulla debitis laboriosam.</div>

        <no-invoice v-if="!this.hasInvoice" :message="$LangMessage(LangKey.NoDownloadInvoice)"/>

        <template v-if="this.hasInvoice">
        <div id="invoice_download_list">
          <div class="unit" v-for="item in invoiceList" >
            <div class="invoice">{{item.sgm_invoice_no}}</div>
            <div class="time">{{$parseTime(item.created * 1000)}}</div>
            <div class="details">
              <span class="pid">{{item.trade_string}}</span>
            </div>
            <div class="func">
              <span class="status pending" icon="history_toggle_off" v-if="item.invoice_status==='created' || item.invoice_status==='requested'">Processing</span>
              <a href="#" @click.stop="doInvoiceDownload(item.sgm_invoice_no)" class="btw download" color="theme" v-if="!checkWebview() && item.invoice_status==='succeed'"><span>Download</span></a>
              <a href="#" @click.stop="showDownload(item.sgm_invoice_no)" class="btw download" color="theme" v-if="checkWebview() && item.invoice_status==='succeed'"><span>Download</span></a>
            </div>
            <div class="msg" v-if="item.invoice_status==='failed' || item.invoice_status==='deleted'">
              <div class="error_msg" icon="info_outline">
                {{item.reject_remark ? item.reject_remark : 'Invalid Information'}}
              </div>
            </div>
          </div>
        </div>
        </template>

      </div>
      <data-loading v-if="loading"/>
    </div>

    <!-- Invoice下载弹窗 -->
    <div id="tukibox_overlay" :class="{show:showLink}">
      <div class="inner">
        <div class="tukibox">
          <div class="tukibox_content DownloadInvoice">
            <div class="inner">
              <div class="art"><img class="lazyload" src="https://seagm-media.seagmcdn.com/mini_store/art-oppo/search.png"  alt="Download Invoice"></div>
              <h3>{{$LangMessage(LangKey.DownloadInvoice)}}</h3>
              <div class="text">{{$LangMessage(LangKey.CantDownLoadInvoice)}}</div>
              <div class="url">{{downloadLink}}</div>
              <div class="btc">
                <a class="btw close" color="theme"><span icon="content_copy" @click.stop="copyDownload(downloadLink)">{{$LangMessage(LangKey.CopyURL)}}</span></a>
                <a class="btw close" color="transparent" href="#" @click.stop="closeDownload"><span>{{$LangMessage(LangKey.Close)}}</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Invoice下载弹窗 -->
  </div>
</template>

<script>
import { DataLoading, NoMoreData } from '@/components'
import MiniStore from "@/api/mini-store"
import NoInvoice from './components/no-invoice'
import { filterNullValueObject } from '@/utils'
import CountryCodes from './components/region/CountryCodes.json';
import StateCodes from './components/region/StateCodes.json';

export default {
  name: "Invoice",
  components: {
    DataLoading,
    NoInvoice,
    NoMoreData
  },
  data() {
    return {
      page: {
        current_page: 1,
        page_size: 15,
        total_pages: 0,
        total_items: 0,
      },
      invoicePage: {
        current_page: 1,
        page_size: 15,
        total_pages: 0,
        total_items: 0,
      },
      dataList: [],
      invoiceList: [],
      showFilter: false,
      loadState: 0,
      loading: false,
      tabShow: true,
      selectReceipts: [],
      invoiceInfo: {
        invoice_type: 'NRIC',
        buyer_name: '',
        buyer_tin: '',
        buyer_identity: '',
        buyer_sst: '',
        buyer_email: '',
        buyer_address: '',
        buyer_contact_number: '',
        buyer_contact_number_code: '',
        buyer_country_code: 'MYS',
        buyer_state_code: '01',
        buyer_city_name: ''
      },
      invoiceInfoList: [],
      CountryCodes: CountryCodes,
      StateCodes: StateCodes,
      showLink: false,
      downloadLink: ''
    }
  },
  computed:{
    hasReceipt() {
       return this.dataList.length > 0
    },
    hasInvoice() {
      return this.invoiceList.length > 0
    },
    noMoreData() {
      return this.page.total_pages > 0 && this.page.current_page >= this.page.total_pages
    },
    noMoreInvoiceData() {
      return this.invoicePage.total_pages > 0 && this.invoicePage.current_page >= this.invoicePage.total_pages
    },
  },
  activated() {
    // 获取值数组
    const CountryCodesValues = CountryCodes.map(item => item['Country']);

    // 根据值进行字母排序
    CountryCodesValues.sort();

    // 将排序后的值放回二维数组中
    this.CountryCodes = CountryCodesValues.map(value => CountryCodes.find(item => item['Country'] === value));

    this.page.current_page = 1
    this.invoicePage.current_page = 1
    this.dataList = []
    this.invoiceList = []
    this.getReceipts()
    this.getInvoices()
    this.getInvoiceInfo();
    // this.getRegion(this.invoiceInfo.buyer_country_code)

    this.invoiceInfo.buyer_email = this.$store.getters.userInfo.email
    window.addEventListener('scroll', this.onReachBottomInvoice, true)
  },
  mounted() {
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onReachBottomInvoice, true)
  },
  deactivated() {
    window.removeEventListener('scroll', this.onReachBottomInvoice, true)
  },
  methods: {
    inputDigt() {
      if (this.invoiceInfo.invoice_type === 'NRIC' || this.invoiceInfo.invoice_type === 'ARMY') {
        const regex = /^\d+$/;
        if (!regex.test(this.invoiceInfo.buyer_identity)) {
          this.loading = false
          this.$tips(this.$LangMessage(this.LangKey.NRICNumber))
          this.$refs.buyerIdentity.scrollIntoView({block: 'center', inline: 'center', behavior:'smooth'})
          this.$refs.buyerIdentity.focus()
          return false;
        }
      }
    },
    changeBuyerRegion() {
      if (this.invoiceInfo.buyer_country_code === 'MYS') {
        this.invoiceInfo.buyer_state_code = '01'
      }

      if (this.invoiceInfo.buyer_country_code !== 'MYS') {
        this.invoiceInfo.buyer_state_code = '17'
      }
    },
    changeInvoiceType() {
      this.invoiceInfo.buyer_identity = '';
    },
    getRegion(code) {
      MiniStore.getRegion({new_code: code}).then(res => {
        if (res.errcode === 200) {
          this.invoiceInfo.buyer_contact_number_code = res.data.country_code
        }
      }).catch(e => {
      })
    },
    showData(bl) {
      this.tabShow = bl
      if (this.tabShow === true) {
        this.page.current_page = 1
        this.dataList = []
        this.getReceipts()
        this.getInvoiceInfo();
      } else {
        this.invoiceList = []
        this.invoicePage.current_page = 1
        this.getInvoices()
      }
    },
    invoiceInfoToNew(invoice) {
      for (const key in invoice) {
        if (this.invoiceInfo.hasOwnProperty(key)) { // 过滤出原型链上的属性
          this.invoiceInfo[key] = invoice[key]
        }
      }
    },
    createInvoice() {
      this.loading = true
      if (!this.invoiceInfo.buyer_city_name) {
        this.loading = false
        this.$tips(this.$LangMessage(this.LangKey.PleaseInputCityName))
        this.$refs.buyerCityName.scrollIntoView({block: 'center', inline: 'center', behavior:'smooth'})
        this.$refs.buyerCityName.focus()
        return false;
      }


      if (!this.invoiceInfo.buyer_name) {
        this.loading = false
        this.$tips(this.$LangMessage(this.LangKey.PleaseInputYourName))
        this.$refs.buyerName.scrollIntoView({block: 'center', inline: 'center', behavior:'smooth'})
        this.$refs.buyerName.focus()
        return false;
      }

      // buyer_identity 非马来西亚地区 brn 可以不填  , PASSPORT直接隐藏
      if (this.invoiceInfo.invoice_type !== 'PASSPORT') {
        if (this.invoiceInfo.buyer_country_code === 'MYS') {
          if (!this.invoiceInfo.buyer_identity) {
            this.loading = false
            this.$tips(this.$LangMessage(this.LangKey.PleaseInputIdentify))
            this.$refs.buyerIdentity.scrollIntoView({block: 'center', inline: 'center', behavior:'smooth'})
            this.$refs.buyerIdentity.focus()
            return false;
          }
        } else {
          if (this.invoiceInfo.invoice_type !== 'BRN' && !this.invoiceInfo.buyer_identity) {
            this.loading = false
            this.$tips(this.$LangMessage(this.LangKey.PleaseInputIdentify))
            this.$refs.buyerIdentity.scrollIntoView({block: 'center', inline: 'center', behavior:'smooth'})
            this.$refs.buyerIdentity.focus()
            return false;
          }
        }
      }

      if (this.invoiceInfo.invoice_type === 'NRIC' || this.invoiceInfo.invoice_type === 'ARMY') {
        const regex = /^\d{12}$/;
        if (!regex.test(this.invoiceInfo.buyer_identity)) {
          this.loading = false
          this.$tips(this.$LangMessage(this.LangKey.NRICNumber))
          this.$refs.buyerIdentity.scrollIntoView({block: 'center', inline: 'center', behavior:'smooth'})
          this.$refs.buyerIdentity.focus()
          return false;
        }
      }


      if (!this.invoiceInfo.buyer_address) {
        this.loading = false
        this.$tips(this.$LangMessage(this.LangKey.PleaseInputAddress))
        this.$refs.address.scrollIntoView({block: 'center', inline: 'center', behavior:'smooth'})
        this.$refs.address.focus()
        return false;
      }

      let receipt_ids = this.selectReceipts.join(',')
      if (!receipt_ids) {
        this.loading = false
        this.$tips(this.$LangMessage(this.LangKey.PleaseSelectPayment))
        return this.$refs.invoiceTradeList.scrollIntoView({block: 'center', inline: 'center', behavior:'smooth'})
      }

      this.$loading(true)
      this.invoiceInfo.receipt_ids = receipt_ids
      filterNullValueObject(this.invoiceInfo)
      MiniStore.createInvoice(filterNullValueObject(this.invoiceInfo)).then(res => {
        this.$loading(false)
        this.loading = false
        if (res.errcode === 200) {
          this.$success('success')
          this.page.current_page = 1
          this.dataList = []
          this.invoiceList = []
          this.getReceipts()
          this.getInvoiceInfo();

          this.tabShow = false
          this.invoicePage.current_page = 1
          this.getInvoices()
        }
      }).catch(e => {
        this.loading = false
        this.$loading(false)
      })

      // document.getElementsByTagName('body')[0].classList.add('tukibox_overlay')
    },
    getInvoiceInfo() {
      MiniStore.getInvoiceInfo().then(res => {
        this.$loading(false)
        this.loading = false
        if (res.errcode === 200) {
          this.invoiceInfoList = res.data
        }
      }).catch(e => {
        this.loading = false
        this.$loading(false)
      })
    },
    getReceipts() {
      if (this.page.current_page === 1) {
        this.$loading(true)
      } else {
        this.loading = true
      }
      MiniStore.getReceipts(this.page).then(res => {
        this.$loading(false)
        this.loading = false
        if (res.errcode === 200) {
          if (this.page.current_page === 1) {
            this.dataList = []
          }

          this.page.current_page = res.data.page.current_page
          this.page.page_size = res.data.page.page_size
          this.page.total_pages = res.data.page.total_pages
          this.page.total_items = res.data.page.total_items
          this.dataList = this.dataList.concat(res.data.list)
        }
        this.loadState++
      }).catch(e => {
        this.loading = false
        this.$loading(false)
        this.loadState++
        //console.log(e)
      })
    },
    getInvoices() {
      if (this.invoicePage.current_page === 1) {
        this.$loading(true)
      } else {
        this.loading = true
      }
      MiniStore.getInvoiceList(this.invoicePage).then(res => {
        this.$loading(false)
        this.loading = false
        if (res.errcode === 200) {
          if (this.invoicePage.current_page === 1) {
            this.invoiceList = []
          }

          this.invoicePage.current_page = res.data.page.current_page
          this.invoicePage.page_size = res.data.page.page_size
          this.invoicePage.total_pages = res.data.page.total_pages
          this.invoicePage.total_items = res.data.page.total_items
          this.invoiceList = this.invoiceList.concat(res.data.list)
        }
        this.loadState++
      }).catch(e => {
        this.loading = false
        this.$loading(false)
        this.loadState++
        //console.log(e)
      })
    },
    onReachBottomInvoice() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 页面滚动的高度
      const clientHeight = document.documentElement.clientHeight // 可视区域高度
      const scrollHeight = document.documentElement.scrollHeight || window.scrollHeight // 可滚动内容的高度
      const bottomOfWindow = scrollTop + clientHeight >= scrollHeight - 200 // 是否触底

      const step2Height = document.getElementById('step2').offsetTop


      // 第二部的时候加载数据
      if (this.tabShow && !this.loading && !this.noMoreData && step2Height - scrollTop <= 200) {
        this.page.current_page += 1
        this.getReceipts()
      }

      if (!this.tabShow && !this.loading && !this.noMoreInvoiceData && bottomOfWindow) {
        this.invoicePage.current_page += 1
        this.getInvoices()
      }
    },
    doInvoiceDownload(sgmInvoiceNo) {
      this.$loading(true)
      const data = {'sgm_invoice_no':sgmInvoiceNo}
      MiniStore.doInvoiceDownload(data).then(res => {
        // 创建一个Blob对象
        const blob = new Blob([res]);

        // 创建一个指向Blob对象的URL
        const blobUrl = URL.createObjectURL(blob);

        // 创建一个a标签用于触发下载
        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.download = 'Invoice_' + sgmInvoiceNo + '.pdf'; // 设置下载的文件名

        // 触发下载
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // 清理
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(blobUrl);
      }).catch(e => {
      })
      this.$loading(false)
    },
    checkWebview() {
      // 获取UserAgent
      var u = navigator.userAgent;
      // 安卓
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
      // IOS
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      return isAndroid||isiOS
    },
    showDownload(val) {
      const domain = window.location.protocol + '//' + window.location.host;
      const url = domain + '/' + this.$store.getters.miniStore.storeCode + '/invoice/' + val
      this.showLink = true
      document.getElementsByTagName('body')[0].classList.add('tukibox_overlay')
      this.downloadLink = url
      // this.$copyText(this.downloadLink)
    },
    copyDownload(val) {
      let self = this
      if (!val) {
        self.$alert(self.$LangMessage(self.LangKey.CopyFail))
      }

      this.$copyText(val).then(
          function(e) {
            self.$success(self.$LangMessage(self.LangKey.CopySuccess))
          },
          function(e) {
            self.$alert(self.$LangMessage(self.LangKey.CopyFail))
          }
      )
    },
    closeDownload() {
      this.showLink = false
      document.getElementsByTagName('body')[0].classList.remove('tukibox_overlay')
      this.downloadLink = ''
    }
  }
}
</script>


<style scoped>

</style>
